import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import "../Sass/Home.scss"
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import arrow from "../Image/icons8-right-arrow-90.png"
import product from "../Image/Mockup/2 (2).png"
import mockup from "../Image/Mockup/collared.jpg"
import arrowbg from "../Image/arrow.png"
import skin from "../Image/Indications/skin health.jpg"
import bone from "../Image/Indications/bone health.jpg"
import anti from "../Image/Indications/anti ageing.jpg"
import hydration from "../Image/Indications/hydration.jpg"
import a1 from "../Image/Assure/1.png"
import a2 from "../Image/Assure/2.png"
import a3 from "../Image/Assure/3.png"
import f1 from "../Image/free/1.png"
// import f2 from "../Image/free/2.png"
// import f3 from "../Image/free/3.png"
// import f4 from "../Image/free/4.png"
import f5 from "../Image/free/5.png"
import f6 from "../Image/free/6.png"
import ortho1 from "../Image/Clinical Studies/before orthopedics.jpg"
import ortho2 from "../Image/Clinical Studies/after orthopedics.jpg"
import skin1 from "../Image/Clinical Studies/before skin.jpg"
import skin2 from "../Image/Clinical Studies/after skin.jpg"
import gynae1 from "../Image/Clinical Studies/before gynae.jpg"
import gyna2 from "../Image/Clinical Studies/after gynae.jpg"
import pancakes from "../Image/Pancakes.jpg"
import smoothie from "../Image/Smoothie.jpg"
import fruitbowl from "../Image/Fruit bowl.jpg"
import rightarrow from "../Image/Clinical Studies/arrow.png"
import { Link as Links, Element } from 'react-scroll';
import slider from "../Image/slider2.png"
import emailjs from '@emailjs/browser';
import fb from "../Firebase/firebase";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const DB = fb.firestore()
const CF = DB.collection('Collared_Form');

const Home2 = () => {

    useEffect(() => {
        // 👇️ scroll to top on page load
        // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        const href = window.location.href.substring(
            window.location.href.lastIndexOf('#') + 1
        );
        const element = document.getElementById(href);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

    }, []);

    const itemsslider = [
        <div class="slider-card car1">
            <div className="text">
                <p>premium collagen designed to support
                    joint health, skin hydration, elasticity, women's health and overall wellness</p>
                {/* <p>premium collagen designed to support</p>

                <ul>
                    <li>joint health</li>
                    <li>skin hydration</li>
                    <li>elasticity</li>
                    <li>women's health</li>
                    <li>overall wellness</li>
                </ul> */}

                {/* <a href="#buy-now">Buy Now</a> */}
                <Links
                    activeClass="active"
                    to="buy"
                    spy={true}
                    smooth={true}
                    offset={-30}
                    duration={100}
                >
                    Buy Now
                </Links>
            </div>
            <img className='img-1' src={product} alt="banner" />

        </div>,
        <div class="slider-card">
            <div className="text">
                <p>bioactive collagen peptide<br />12.5 gram sachet</p>
                {/* <a href="#buy-now">Buy Now</a> */}
                <Links
                    activeClass="active"
                    to="buy"
                    spy={true}
                    smooth={true}
                    offset={-30}
                    duration={100}
                >
                    Buy Now
                </Links>
            </div>
            <img className='img-2' src={product} alt="banner" />

        </div>,
    ];

    // header

    const [navBg, setNavBg] = useState("");
    const [shadow, setShadow] = useState("");

    const changeNavBg = () => {
        window.scrollY >= 200 ? setNavBg("#E7E1D7") : setNavBg("transparent");
        window.scrollY >= 200 ? setShadow("2px 2px 5px rgba(0,0,0,0.3)") : setShadow("none");
    }

    window.addEventListener('scroll', changeNavBg);
    // header ends

    // orthopedics

    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
    };

    const items = [
        <div className="orthopedics-card">
            <h3>boost cartilage repair</h3>
            {/* <h4>bioactive collagen peptide</h4> */}
            <p>It repairs and regenerates cartilage by enhancing cartilage-producing cells, improving overall joint health and proper body function.</p>
        </div>,
        <div className="orthopedics-card">
            <h3>enhances joint
                function</h3>
            <p>These bioactive collagen peptides improve joint movement and flexibility. Regular use of collagen can lead to less stiffness and better joint function.
            </p>
        </div>,
        <div className="orthopedics-card">
            <h3>enhances
                tendon and
                ligament repair</h3>
            <p>Bioactive collagen peptide enhances the extracellular matrix of tendons and ligaments, essential for tissue repair.
            </p>
        </div>,
        <div className="orthopedics-card">
            <h3>improves
                elasticity and
                flexiblity</h3>
            <p>Collagen peptides help to increase the collagen matrix in tendons and ligaments, thus improving overall joint health and reducing the risk of injuries.
            </p>
        </div>,
        <div className="orthopedics-card">
            <h3>connective
                tissue health
            </h3>
            <p>The bioactive collagen peptide helps maintain the integrity and function of the connective tissues.</p>
        </div>
    ];

    // orthopedics ends

    // gynaecology 

    const responsive2 = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
    };

    const items2 = [
        <div className="gynaecology-card">
            <span>1</span>
            <h3>Supports for Uterine Health</h3>
            <p>The collagen peptide provides biomechanical strength and structural integrity, which are necessary for the proper functioning of the uterus.</p>
            {/* <img src={arrowbg} alt="" /> */}
        </div>,
        <div className="gynaecology-card">
            <span>2</span>
            <h3>Hormonal Balance</h3>
            <p>Collagen contributes to overall hormonal balance by supporting the production of key hormones that regulate the menstrual cycle.
            </p>
            {/* <img src={arrowbg} alt="" /> */}

        </div>,
        <div className="gynaecology-card">
            <span>3</span>
            <h3>Joint and Muscle Support for Postmenopausal Women</h3>
            <p>Collagen peptides can be beneficial in supporting bone mineral density in postmenopausal women and may reduce the risk of fractures.</p>
            {/* <img src={arrowbg} alt="" /> */}

        </div>,
        <div className="gynaecology-card">
            <span>4</span>
            <h3>Supportive in Gynecological Surgeries</h3>
            <p>Collagen peptides accelerate wound healing and are also beneficial for tissue repair.
            </p>
            {/* <img src={arrowbg} alt="" /> */}

        </div>,
        <div className="gynaecology-card">
            <span>5</span>
            <h3>Pelvic Organ Prolapse</h3>
            <p>strengthen the pelvic tissues potentially reducing the severity of prolapse.</p>
        </div>
    ];
    // gynaecology ends

    // why

    const [read, setRead] = useState("none");

    const openRead = () => {
        setRead("block");
    }
    const closeRead = () => {
        setRead("none");
    }
    // why ends

    // diet
    const [showsmoothie, setShowSmoothie] = useState("none");

    const openSmoothie = () => {
        setShowSmoothie("block");
    }
    const closeSmoothie = () => {
        setShowSmoothie("none");
    }

    const [showfruit, setShowFruit] = useState("none");

    const openFruit = () => {
        setShowFruit("block");
    }
    const closeFruit = () => {
        setShowFruit("none");
    }

    const [showPancake, setShowPancake] = useState("none");

    const openPancake = () => {
        setShowPancake("block");
    }
    const closePancake = () => {
        setShowPancake("none");
    }

    // diet ends

    // contact form

    const form = useRef();
    const [userData, setUserData] = useState({
        Name: "",
        Email: "",
        Mobile: "",
        Quantity: "",
        RetailerSelfUse: ""
    });

    let name, value;
    const postUserData = (e) => {
        name = e.target.name;
        value = e.target.value;
        setUserData({ ...userData, [name]: value });
    }

    //connect with firebase
    const SubmitData = async (e) => {
        e.preventDefault();
        const { Name, Email, Mobile, Quantity, RetailerSelfUse } = userData;
        if (Name && Email && Mobile && Quantity && RetailerSelfUse) {


            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (!emailRegex.test(userData.Email)) {
                toast.warning('Please enter a valid email address');
                return
            }

            if (typeof Mobile !== "undefined") {

                var pattern = new RegExp(/^[0-9\b]+$/);

                if (!pattern.test(userData.Mobile)) {
                    toast.warning("Please enter only number.");
                    return

                } else if (userData.Mobile.length !== 10) {
                    toast.warning("Please enter 10 digit Mobile number.");
                    return
                }
            }

            try {

                CF.add({
                    Name: Name,
                    Email: Email,
                    Mobile: Mobile,
                    Quantity: Quantity,
                    RetailerSelfUse: RetailerSelfUse
                }).then((docRef) => {
                    toast.success('Order Received Successfully');
                }).catch((error) => {
                    console.error("error:", error);
                });

                emailjs.sendForm('service_91sqknx', 'template_4j6wwya', form.current, '6pbmyufjSURA60XeS')
                    .then((result) => {
                        console.log(result.text);

                    }, (error) => {
                        console.log(error.text);
                    });

                setUserData({
                    Name: "",
                    Email: "",
                    Mobile: "",
                    Quantity: "",
                    RetailerSelfUse: ""
                })

                // console.log("Document written with ID: ", docRef.id);
            } catch (e) {
                console.error("Error adding document: ", e);
                toast.warning("Error adding document")
            }
        }
        else {
            toast.warning('Please fill the data');
        }
    };

    // contact form dancing


    const [display, setDisplay] = useState("none");

    const show = () => {
        setDisplay("block");
    }

    const hide = () => {
        setDisplay("none");
    }

    const up = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setDisplay("none");
    }

    const [animation, setAnimation] = useState("zoom-in-zoom-out 2s ease-out 1");

    const down = () => {
        window.scrollTo({ top: 10000, left: 0 });
        setDisplay("none");

        if (animation === "zoom-in-zoom-out 2s ease-out 1") {
            setAnimation("none");
        }
        else {
            setAnimation("zoom-in-zoom-out 2s ease-out 1");
        }
    }

    const hidden = () => {
        setDisplay("none");
    }


    return (

        <>
            <ToastContainer />

            <header style={{ background: navBg, boxShadow: shadow }}>
                <div className="logo">
                    {/* <img rel='preload' fetchpriority="high" src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702125402/Collared/logo_zjql0r.webp" alt="logo" /> */}
                    <h1>Collared</h1>

                </div>
                <div className="links">
                    <Link to={"/"} onClick={up}>Home</Link>
                    <Links
                        activeClass="active"
                        to="about"
                        spy={true}
                        smooth={true}
                        offset={-40}
                        duration={100}
                    >
                        About Collared
                    </Links>
                    <Links
                        activeClass="active"
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={100}
                    >
                        Contact Us
                    </Links>
                    <Links
                        activeClass="active"
                        to="buy"
                        spy={true}
                        smooth={true}
                        offset={-30}
                        duration={100}
                    >
                        Buy Now
                    </Links>


                    {/* <a onClick={hidden} href="#about">About Collared</a> */}
                    {/* <a href="#contact-us" onClick={down}>Contact Us</a>
                    <a onClick={hidden} href="#buy-now">Buy Now</a> */}
                </div>

                <div id='navbar-mobile' style={{ display: display }}>
                    <svg className='cross' onClick={hide} id="Capa_1" enable-background="new 0 0 320.591 320.591" height="512" viewBox="0 0 320.591 320.591" width="512" xmlns="http://www.w3.org/2000/svg"><g><g id="close_1_"><path d="m30.391 318.583c-7.86.457-15.59-2.156-21.56-7.288-11.774-11.844-11.774-30.973 0-42.817l257.812-257.813c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875l-259.331 259.331c-5.893 5.058-13.499 7.666-21.256 7.288z" /><path d="m287.9 318.583c-7.966-.034-15.601-3.196-21.257-8.806l-257.813-257.814c-10.908-12.738-9.425-31.908 3.313-42.817 11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414-6.35 5.522-14.707 8.161-23.078 7.288z" /></g></g></svg>

                    <div className="links">
                        <Link to={"/"} onClick={up}>Home</Link>
                        <Links
                            onClick={hidden}
                            activeClass="active"
                            to="about"
                            spy={true}
                            smooth={true}
                            offset={-20}
                            duration={100}
                        >
                            About Collared
                        </Links>
                        <Links
                            activeClass="active"
                            to="contact"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={100}
                            onClick={down}
                        >
                            Contact Us
                        </Links>
                        <Links
                            onClick={hidden}
                            activeClass="active"
                            to="buy"
                            spy={true}
                            smooth={true}
                            offset={-50}
                            duration={100}
                        >
                            Buy Now
                        </Links>
                        {/* <a onClick={hidden} href="#about">About Collared</a>
                        <a onClick={down} href="#contact">Contact</a>
                        <a onClick={hidden} href="#buy">Buy Now</a> */}

                    </div>
                </div>
                <svg className='menu' onClick={show} id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m512 256.002c0 17.673-14.327 32-32 32h-307.059c-17.673 0-32-14.327-32-32s14.327-32 32-32h307.059c17.673 0 32 14.327 32 32zm-339.059-134.55h307.059c17.673 0 32-14.327 32-32s-14.327-32-32-32h-307.059c-17.673 0-32 14.327-32 32s14.328 32 32 32zm307.059 269.096h-307.059c-17.673 0-32 14.327-32 32s14.327 32 32 32h307.059c17.673 0 32-14.327 32-32s-14.327-32-32-32zm-419.195-333.096h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32zm0 166.551h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32zm0 166.542h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32z" /></svg>


            </header>

            {/* <div className="slider">
                <div className="slider-body">
                    <AliceCarousel
                        mouseTracking
                        items={itemsslider}
                        // responsive={responsive4}
                        controlsStrategy="alternate"
                        autoPlay={true}
                        infinite={true}
                        autoPlayInterval={4000}
                        disableDotsControls={true}
                        renderPrevButton={() => {
                            return <img src={arrow} alt="" />
                            //  <svg enable-background="new 0 0 32 32" height="300" viewBox="0 0 32 32" width="300" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs"><g transform="matrix(1,0,0,1,0,0)"><g id="Guide"><path d="m-136-10h346v220h-346z" fill="#ffffff00" data-original-color="#ffffffff" stroke="none"/></g><g id="Line" display="none"><path d="m8.5 31 15-15-15-15" style="display: inline; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10;" fill="none" stroke="#3e363eff" data-original-stroke-color="#111111ff" stroke-width="2" data-original-stroke-width="2"/></g><g id="Line_Expand"><path d="m8.5 32c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l14.3-14.3-14.3-14.29c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l15 15c.39.39.39 1.02 0 1.41l-15 15c-.19.19-.44.29-.7.29z" fill="#3e363eff" data-original-color="#111111ff" stroke="none"/></g></g></svg>
                        }}
                        renderNextButton={() => {
                            return <img src={arrow} alt="" />
                            // <svg enable-background="new 0 0 32 32" height="300" viewBox="0 0 32 32" width="300" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs"><g transform="matrix(1,0,0,1,0,0)"><g id="Guide"><path d="m-136-10h346v220h-346z" fill="#ffffff00" data-original-color="#ffffffff" stroke="none"/></g><g id="Line" display="none"><path d="m8.5 31 15-15-15-15" style="display: inline; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10;" fill="none" stroke="#3e363eff" data-original-stroke-color="#111111ff" stroke-width="2" data-original-stroke-width="2"/></g><g id="Line_Expand"><path d="m8.5 32c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l14.3-14.3-14.3-14.29c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l15 15c.39.39.39 1.02 0 1.41l-15 15c-.19.19-.44.29-.7.29z" fill="#3e363eff" data-original-color="#111111ff" stroke="none"/></g></g></svg>
                        }}
                    />
                </div>
            </div> */}

            <div className="banner">
                <img src={slider} alt="banner" />
                <div class="banner-card ">
                    <p>premium collagen designed to support
                        joint health, skin hydration, elasticity, women's health and overall wellness</p>
                    <Links
                        activeClass="active"
                        to="buy"
                        spy={true}
                        smooth={true}
                        offset={-30}
                        duration={100}
                    >
                        Buy Now
                    </Links>
                </div>
            </div>

            <div className="collared">
                <Element name="about" className="element">
                    <section className="about" id='about'>

                        <div className="title">
                            <h4>High Quality Collagen Design for Excellence</h4>
                            <p>Safe, Advanced Collagen, Clinically Proved.</p>
                        </div>
                        <div className="about-body">
                            <img src={mockup} alt="" />
                            <div className="about-text">
                                <p>Collared S/F Orange Flavor Sachet 12.5 gm is a Bioactive Collagen Peptide used to strengthen bones, promote bone growth, enhance wound repair and healing and provide lubrication to the joints. Collared S/F Orange Flavor Sachet 12.5 gm is also used to treat various bone disorders such as osteoarthritis</p>

                                <div className="about-points">
                                    <ul>
                                        <li>

                                            <div className="svg">

                                                <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                            </div>
                                            <div className="pt">
                                                <h6>Key Ingredients</h6>
                                                <p> Collagen peptides <b>12.5 gm sachet</b></p>
                                            </div>

                                        </li>

                                        <li>

                                            <div className="svg">

                                                <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                            </div>

                                            <div className="pt">
                                                <h6>Directions For Use</h6>
                                                <p>Mix collagen powder with water and drink.</p>
                                            </div>

                                        </li>

                                        <li>
                                            <div className="svg">

                                                <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                            </div>

                                            <div className="pt">
                                                <h6>How Collared S/F Works</h6>
                                                <p>Collared S/F Orange Flavor Sachet 12.5 gm works by enhancing bone health by promoting the production of bone cells and cartilage and assisting in wound repair and healing.</p>
                                            </div>

                                        </li>
                                    </ul>

                                </div>

                                <Links
                                    activeClass="active"
                                    to="buy"
                                    spy={true}
                                    smooth={true}
                                    offset={-30}
                                    duration={100}
                                >
                                    Buy Now
                                </Links>
                            </div>
                        </div>
                    </section>
                </Element>
                <section className="assure">
                    <div className="title">
                        <h4>We Assure You</h4>
                        <p></p>
                    </div>
                    <div className="assure-body">
                        <ul>
                            <li>
                                <img src={a1} alt="" />
                                <p>It is natural with no added additives, beneficial for longer time.</p>
                            </li>
                            <li>
                                <img src={a2} alt="" />
                                <p>Effective collagen that absorbs well and works efficiently.
                                </p>
                            </li>
                            <li>
                                <img src={a3} alt="" />
                                <p>Clinically proven for unmatched results.</p>
                            </li>
                        </ul>
                        <p>We assure your <span>safety, high performance collagen,</span> clinically proved and tested by skin <span>experts</span></p>
                    </div>
                </section>
                <section className="orthopedics">
                    <div className="title">
                        <h4>
                            for orthopedics use
                        </h4>
                        <p>Revitalize your joints by boosting collagen and elastin for stronger cartilage, tendons, and ligaments</p>
                    </div>

                    <div className="orthopedics-body">
                        <AliceCarousel
                            mouseTracking
                            items={items}
                            responsive={responsive}
                            controlsStrategy="alternate"
                            autoPlay={true}
                            infinite={true}
                            autoPlayInterval={1500}
                            disableDotsControls={true}
                            renderPrevButton={() => {
                                return <svg className='prev' id="Glyph" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m12 1.25c-5.9277 0-10.75 4.8223-10.75 10.75s4.8223 10.75 10.75 10.75 10.75-4.8223 10.75-10.75-4.8223-10.75-10.75-10.75zm-3.3721 15.0498c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121l-3.6113 3.3877zm8.6113-3.3877-3.6113 3.3877c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121z" /></svg>
                            }}
                            renderNextButton={() => {
                                return <svg className='next' id="Glyph" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m12 1.25c-5.9277 0-10.75 4.8223-10.75 10.75s4.8223 10.75 10.75 10.75 10.75-4.8223 10.75-10.75-4.8223-10.75-10.75-10.75zm-3.3721 15.0498c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121l-3.6113 3.3877zm8.6113-3.3877-3.6113 3.3877c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121z" /></svg>
                            }}
                        />

                    </div>
                </section>

                <section className="indications">
                    <div className="title">
                        <h4>Indications</h4>
                        <p></p>
                    </div>

                    <div className="indications-body">
                        <div className="indications-card">
                            <img src={bone} alt="" />
                            <div className="indications-text">
                                <h3>Bone density</h3>
                                <p>Improves bone mineral density, especially in postmenopausal women</p>
                            </div>
                        </div>
                        <div className="indications-card">
                            <img src={anti} alt="" />
                            <div className="indications-text">
                                <h3>Anti-ageing</h3>
                                <p>Reduces the appearance of wrinkles and fine lines</p>
                            </div>
                        </div>
                        <div className="indications-card">
                            <img src={hydration} alt="" />
                            <div className="indications-text">
                                <h3>Hydration</h3>
                                <p>Enhances skin hydration and elasticity</p>
                            </div>
                        </div>
                        <div className="indications-card">
                            <img src={skin} alt="" />
                            <div className="indications-text">
                                <h3>Complexion</h3>
                                <p>Improves overall skin tone and texture</p>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="dosage">
                    <div className="title">
                        <h4>Dosage and Usage Instructions</h4>
                        <p></p>
                    </div>
                    <div className="dosage-body">
                        <p>Take Collared as directed by your physician. For best results, follow the
                            recommended dosage and consult your healthcare provider for personalized advice.</p>
                    </div>
                </section>

                <section className="gynaecology">
                    <div className="title">
                        <h4>For gynaecological Health</h4>
                        <p></p>
                    </div>

                    <div className="gynaecology-body">
                        <AliceCarousel
                            mouseTracking
                            items={items2}
                            responsive={responsive2}
                            controlsStrategy="alternate"
                            autoPlay={true}
                            infinite={true}
                            autoPlayInterval={1500}
                            disableDotsControls={true}
                            renderPrevButton={() => {
                                return <svg id="Layer_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256zm76.5 264.5-136 136c-2.3 2.3-5.4 3.5-8.5 3.5s-6.2-1.2-8.5-3.5c-4.7-4.7-4.7-12.3 0-17l127.6-127.5-127.6-127.5c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l136 136c4.7 4.7 4.7 12.3 0 17z" /></svg>
                            }}
                            renderNextButton={() => {
                                return <svg id="Layer_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256zm76.5 264.5-136 136c-2.3 2.3-5.4 3.5-8.5 3.5s-6.2-1.2-8.5-3.5c-4.7-4.7-4.7-12.3 0-17l127.6-127.5-127.6-127.5c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l136 136c4.7 4.7 4.7 12.3 0 17z" /></svg>
                            }}
                        />
                    </div>
                </section>

                <section className="clinical">
                    <div className="title">
                        <h4>Collared Collagen<br />
                            Results Proven by Clinical Studies</h4>
                        <p>See the Transformation</p>
                    </div>
                    <div className="clinical-body">
                        <div className="clinical-card">
                            <h5>Transforming joint health with Collared</h5>
                            <div className="img">
                                <img src={ortho1} alt="before" />
                                <img src={ortho2} alt="after" />
                            </div>
                            <div className="span">
                                <span>Before</span>
                                <span>After</span>
                            </div>
                            <ul>
                                <li>  <div className="svg">

                                    <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                </div>
                                    Enhanced joint mobility
                                </li>
                                <li>
                                    <div className="svg">

                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                    </div>
                                    Improves cartilage function
                                </li>
                                <li>
                                    <div className="svg">

                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                    </div>
                                    Overall bone health
                                </li>
                            </ul>
                            <h6>Joint Health</h6>
                            {/* <p>Collagen peptides play a crucial role in maintaining joint health by supporting the structure and function of cartilage, which is essential for joint comfort and mobility.</p> */}
                        </div>
                        <div className="clinical-card">
                            <h5>improves skin surface in the cellulite</h5>
                            <div className="img">
                                <img src={skin1} alt="before" />
                                <img src={skin2} alt="after" />
                            </div>
                            <div className="span">
                                <span>Before</span>
                                <span>After</span>
                            </div>

                            <ul>
                                <li>
                                    <div className="svg">

                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                    </div>
                                    Penetration of active collagen peptide into the skin
                                </li>
                                <li>
                                    <div className="svg">

                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                    </div>
                                    Overall improvement in skin wrinkles
                                </li>
                            </ul>
                            <h6>Skin</h6>
                        </div>
                        <div className="clinical-card">
                            <h5>collared actively works in the osteoarthritis for women</h5>
                            <div className="img">
                                <img src={gynae1} alt="before" />
                                <img src={gyna2} alt="after" />
                            </div>
                            <div className="span">
                                <span>Before</span>
                                <span>After</span>
                            </div>
                            <ul>
                                <li>  <div className="svg">

                                    <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                </div>
                                    It helps to improve cartilage repair
                                </li>
                                <li>
                                    <div className="svg">

                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                    </div>
                                    Reduce inflammation
                                </li>
                                <li>
                                    <div className="svg">

                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="43.349mm" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 43.3492 43.3492" width="43.349mm" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m18.7919 40.4666c-10.3656 0-18.7919-8.4264-18.7919-18.792s8.4263-18.792 18.7919-18.792c4.7533 0 9.2138 1.7264 12.689 4.912-1.1559.6835-2.2714 1.4406-3.3443 2.2601-2.6332-2.1243-5.9073-3.2939-9.3447-3.2939-8.2149 0-14.9137 6.6989-14.9137 14.9138s6.6988 14.9138 14.9137 14.9138c11.4303 0 18.2165-12.2181 13.3002-21.7178.7451-.6929 1.512-1.3645 2.2992-2.0137.2324-.1917.4668-.3816.7029-.5696 1.6446 2.8405 2.49 6.0611 2.49 9.3872-.0002 10.3657-8.4266 18.7921-18.7923 18.7921z" /><path d="m19.2856 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z" /></g></svg>
                                    </div>
                                    Overall bone health
                                </li>
                            </ul>
                            <h6>Gynaecology</h6>

                        </div>
                    </div>
                </section>

                <section className="free">
                    <div className="title">
                        <h4>Pure goodness without the extras</h4>
                        <p></p>
                    </div>
                    <div className="free-body">
                        {/* <div className="free-card">
                            <img src={f1} alt="" />
                            <p>no added colors</p>
                        </div>
                        <div className="free-card">
                            <img src={f2} alt="" />
                            <p>no preservatives</p>
                        </div> */}
                        <div className="free-card">
                            <img src={f1} alt="" />
                            <p>no additives</p>
                        </div>
                        <div className="free-card">
                            <img src={f5} alt="" />
                            <p>contains no gluten</p>
                        </div>
                        <div className="free-card">
                            <img src={f6} alt="" />
                            <p>completely nut free, dairy free and soy free</p>
                        </div>
                    </div>
                </section>

                <section className="why">
                    <div className="title">
                        <h4>Why collared collagen works</h4>
                        <p></p>
                    </div>

                    <div className="why-body">
                        <div className="why-body-left">
                            <div className="why-card">
                                <h3>doses supported by clinical studies</h3>
                                <p> assuring proper uniformity</p>
                            </div>

                            <div className="why-card">
                                <h3>excellent
                                    absorption rate</h3>
                                <p></p>
                            </div>
                        </div>
                        <div className="why-body-right">

                            <div className="why-card">
                                <h3>microsized collagen for
                                    peak absorption</h3>
                                <p></p>
                            </div>

                            <div className="why-card">
                                <h3>200 % more productive</h3>
                                <p>at
                                    enhancing collagen production</p>
                            </div>
                        </div>
                    </div>

                    <p className="readbtn" onClick={openRead}>Read More</p>

                    <div className="read" style={{ display: read }}>
                        <svg onClick={closeRead} xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="512" height="512"><path d="M14.121,12,18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z" /></svg>

                        <ul>
                            <li><b>Doses supported by clinical studies:</b> We are using only clinically supported doses to ensure proper uniformity.</li>
                            <li>Microsized collagen for peak absorption</li>
                            <li><b>Excellent absorption rate and genuine digestiblity:</b> Collared offers genuine digestiblity for superior
                                results</li>
                            <li>Collared offers 200 % more productive collagen as compared to standard collagen</li>
                        </ul>
                    </div>

                </section>

                <section className="imageBanner">
                    <h4>Empowering confidence through pure wellness and radiant beauty</h4>
                    <p>Experience the purity of 100% pure premium collagen, flexible, multipurpose refined for you</p>
                </section>

                <section className="table">
                    <div className="title">
                        <h4>Collared Vs Conventional Collagen</h4>
                        <p></p>
                    </div>
                    <div className="table-body">
                        <div className="row1">
                            <div className="col">
                            </div>
                            <div className=" col">
                                Collared
                            </div>
                            <div className=" col">
                                Conventional Collagen
                            </div>
                        </div>
                        <div className="row1">
                            <div className="col1">
                                Absorption and Bioavailability
                            </div>
                            <div className="col2">
                                Contains bioactive collagen peptides that are broken down into smaller, easily
                                absorbed molecules. These peptides are crafted for optimal bioavailability, ensuring they are
                                quickly absorbed and utilized by the body.
                            </div>
                            <div className="col3">Cannot be broken down easily due to larger molecules and requires
                                more energy to break into usable peptides.
                            </div>
                        </div>
                        <div className="row1">
                            <div className="col1">
                                Targeted Benefits
                            </div>
                            <div className="col2">
                                Specifically targets your joints, tendons, and ligaments, helping them to repair and
                                strengthen.
                            </div>
                            <div className="col3">
                                Does not focus on specific targets in the areas that need it most.
                            </div>
                        </div>
                        <div className="row1">
                            <div className="col1">
                                Proven Results
                            </div>
                            <div className="col2">
                                Clinical studies show that Collared works faster and delivers better results for joint
                                health, skin appearance, and overall wellness.
                            </div>
                            <div className="col3">
                                Usually takes a longer time for noticeable changes.
                            </div>
                        </div>
                        <div className="row1">
                            <div className="col1">
                                Formulated for effectiveness
                            </div>
                            <div className="col2">
                                Each dose is carefully measured to give the best results.
                            </div>
                            <div className="col3">
                                The doses will vary, so results will not be consistent.
                            </div>
                        </div>
                        <div className="row1">
                            <div className="col1">
                                faster noticeable improvements
                            </div>
                            <div className="col2">
                                People who use Collared will notice quicker improvements in how they feel and
                                look.
                            </div>
                            <div className="col3">
                                Might work, but it has lower and less targeted effects.
                            </div>
                        </div>
                    </div>
                </section>

                {/* <div className="versus">
                    <div className="title">
                        <h4>Collared formulation vs other collagen</h4>
                        <p></p>
                    </div>

                    <div className="versus-body">
                        <div className="versus-left">
                            <div className="versus-img">
                                <img src={v1} alt="diagram 1" />
                                <img src={v2} alt="diagram 2" />
                            </div>

                            <div className="versus-left-text">
                                <p>1x collared collagen<br /> = 1 clinical doses</p>
                                <p>5x to 10x other collagen<br /> = 1 clinical dose</p>
                            </div>
                        </div>
                        <div className="versus-right">
                            <ul>
                                <li>We offer you 100 % pure, premium collagen for maximum effectiveness</li>
                                <li>Our collagen is free from minimum odor with no heavy flavoring agents</li>
                                <li>Most manufacturers uses synthetic additives to prevent clogging in manufacturing, we use premium collagen making our product free from artificial substances</li>
                            </ul>
                        </div>
                    </div>
                </div> */}

                <section className="diet">
                    <div className="title">
                        <h4>Collagen in your daily diet</h4>
                        <p></p>
                    </div>

                    <div className="diet-body">
                        <div className="diet-card">
                            <img src={smoothie} alt="pancakes" />
                            <div className="text">
                                <h3>Collagen in Smoothie</h3>
                                <button onClick={openSmoothie}>recipe</button>
                            </div>

                            <div className="diet-recipe" style={{ display: showsmoothie }}>
                                <svg onClick={closeSmoothie} xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="512" height="512"><path d="M14.121,12,18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z" /></svg>
                                <h3>Collagen in Smoothie</h3>
                                <p>Collagen helps us to build and repair muscles and bones, and generates the production
                                    of important hormones and enzymes. A collagen protein shake means you’re getting valuable
                                    nutrients in your diet, alongside boosting your collagen levels. It also tastes really good!</p>

                                <h4>Ingredients</h4>
                                <ol>
                                    <li>1 Collared collagen sachet</li>
                                    <li> 1 small banana</li>
                                    <li> 1 cup semi-skimmed milk or milk alternative</li>
                                    <li> 1 tbsp strawberries</li>
                                    <li> 1/2 cup Greek yoghurt</li>
                                </ol>

                                <h4>Directions</h4>
                                <ul>
                                    <li>Once again, you’ll need your trusty blender to get started</li>
                                    <li>   Tear the banana into pieces again (we find it just blends easier that way)</li>
                                    <li>    Chop your strawberries and chuck them in</li>
                                    <li>      Add the Greek yoghurt</li>
                                    <li>     Pour over the milk</li>
                                    <li>    Blend everything together</li>
                                    <li>    Add in your Collared sachet and stir it in</li>
                                    <li>   Pour into a tall glass and enjoy</li>
                                    <li>You’ll need to drink your collagen protein shake pretty soon after you make it, as it can set and be
                                        less enjoyable. It’s a great post-workout treat or a midday pick-me-up, so make one as soon as you
                                        know you’ll be drinking it to make sure it tastes as good as it should.</li>
                                </ul>
                            </div>

                        </div>
                        <div className="diet-card">
                            <img src={fruitbowl} alt="pancakes" />
                            <div className="text">
                                <h3>Collagen in Fruit Bowl</h3>
                                <button onClick={openFruit}>recipe</button>
                            </div>


                            <div className="diet-recipe" style={{ display: showfruit }}>
                                <svg onClick={closeFruit} xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="512" height="512"><path d="M14.121,12,18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z" /></svg>
                                <h3>Collagen in Fruit Bowl </h3>

                                <h4>Directions</h4>
                                <ul>
                                    <li>Wash the fruit and chop it up into evenly sized pieces, then add it to a large mixing bowl.</li>
                                    <li>Sprinkle the collared collagen sachet mixture with yoghurt and extracts over the fruit and then stir
                                        gently to combine.</li>
                                    <li>Refrigerate this for a few hours to create that delicious glaze on the fruit!
                                        Serve and enjoy!
                                    </li>
                                </ul>
                            </div>

                        </div>
                        <div className="diet-card">
                            <img src={pancakes} alt="pancakes" />
                            <div className="text">
                                <h3>Collagen in Pancake</h3>
                                <button onClick={openPancake}>recipe</button>
                            </div>


                            <div className="diet-recipe" style={{ display: showPancake }}>
                                <svg onClick={closePancake} xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="512" height="512"><path d="M14.121,12,18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z" /></svg>
                                <h3>Collagen in Pancake</h3>
                                <p>Collagen helps us to build and repair muscles and bones, and generates the production
                                    of important hormones and enzymes. A collagen protein shake means you’re getting valuable
                                    nutrients in your diet, alongside boosting your collagen levels. It also tastes really good!</p>

                                <h4>Ingredients</h4>
                                <ol>
                                    <li>1 Banana</li>
                                    <li>3 eggs</li>
                                    <li>1 sachet collared collagen</li>
                                    <li>Raw Butter to cook with</li>
                                </ol>

                                <h4>Directions</h4>
                                <ul>
                                    <li>Mash banana in a medium bowl.</li>
                                    <li>Add 3 eggs and whisk together with banana.</li>
                                    <li>Add 1 sachet of Collared collagen peptide to mixture and whisk together.</li>
                                    <li>Use ¼-1/2 cup of “batter” at a time in a pre-heated and greased skillet (with raw butter) over
                                        medium heat, flip when edges begin to appear cooked. About 1-2 minutes on each side.</li>
                                    <li>Serve and enjoy! You can put a drizzle of maple syrup on top and have a side of berries and an over
                                        easy egg. That is a complete animal-based diet breakfast! SO GOOD!</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <Element name="buy" className="element">
                    <section className="contact" id="buy-now">
                        <div className="title">
                            <h4>Buy Now</h4>
                            <p></p>
                        </div>
                        <div className="contact-body">
                            <form action="POST" ref={form}>
                                <div className="form">
                                    <input type="text" placeholder='Full Name'
                                        name='Name'
                                        value={userData.Name}
                                        onChange={postUserData}
                                        required
                                    />
                                    <input type="email" placeholder='Email Address'
                                        name='Email'
                                        value={userData.Email}
                                        onChange={postUserData}
                                        required
                                    />
                                    <input type="text" placeholder='Mobile'
                                        name='Mobile'
                                        value={userData.Mobile}
                                        onChange={postUserData}
                                        required
                                    />
                                    <input style={{ display: "none" }}
                                        type="text"
                                        name="productName"
                                        value="Collared"
                                    />
                                    <input type="number" placeholder='Quantity' name='Quantity'
                                        min={1}
                                        value={userData.Quantity}
                                        onChange={postUserData}
                                        required
                                    />
                                    <select id="" className="form-control" name='RetailerSelfUse'
                                        value={userData.RetailerSelfUse}
                                        onChange={postUserData} >
                                        <option value="retailer/self use" selected>Retailer / Self Use</option>
                                        <option value="Retailer">Retailer</option>
                                        <option value="Self Use">Self Use</option>
                                    </select>
                                    {/* <input type="text" placeholder='Retailer / Self Use' /> */}
                                </div>

                                <button onClick={SubmitData}>Place Order</button>
                            </form>
                        </div>

                        {/* <section class="contact section" id="contact">
                            <div class="contact__container grid">

                                <div class="contact__mail">

                                    <form action="" class="contact__form" id="contact-form">
                                        <div class="contact__group">
                                            <div class="contact__box">
                                                <input type="text" name="user_name" class="contact__input" id="name" required placeholder="Full name" />
                                                <label for="name" class="contact__label"> Full Name</label>
                                            </div>

                                            <div class="contact__box">
                                                <input type="email" name="user_email" class="contact__input" id="email" required placeholder="Email Address" />
                                                <label for="email" class="contact__label">Email Address</label>
                                            </div>
                                        </div>

                                        <div class="contact__group">
                                            <div class="contact__box">
                                                <input type="text" name="user_name" class="contact__input" id="name" required placeholder="Mobile" />
                                                <label for="name" class="contact__label">Mobile</label>
                                            </div>

                                            <div class="contact__box">
                                                <input type="email" name="user_email" class="contact__input" id="email" required placeholder="Quantity" />
                                                <label for="email" class="contact__label">Quantity</label>
                                            </div>
                                        </div>

                                        <div class="contact__group">
                                            <div class="contact__box">
                                                <input type="text" name="user_name" class="contact__input" id="name" required placeholder="Retailer / Self Use" />
                                                <label for="name" class="contact__label">Retailer / Self Use</label>
                                            </div>
                                        </div>

                                        <p class="contact__message" id="contact-message"></p>

                                        <button type="submit" class="contact__button button">
                                            <i class="ri-send-plane-line"></i>Place Order
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </section> */}
                    </section>
                </Element>
            </div>
            <Element name="contact" className="element">
                <footer id='contact'>
                    <div className="footer-top">
                        <div className="footer-subscribe">
                            <h3>Bring a newness with collared</h3>
                            <p>Subscribe and rediscover radiance, confidence and unseen insights </p>

                            <div className="subscribe">
                                <input type="text" placeholder='Enter Your Email' />
                                <button>Subscribe</button>
                            </div>

                            <div class="footer-follow">
                                <a target="_blank" rel="noreferrer" href="https://www.facebook.com/akcenthealthcaresales/">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
                                </a>

                                {/* <a target="_blank" rel="noreferrer" href="https://twitter.com/AkcentHealthca1">

                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>

                            </a> */}


                                <a target="_blank" href="https://www.instagram.com/AkcentHealthCare">
                                    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m6.5 1c-3.03757 0-5.5 2.46243-5.5 5.5v11c0 3.0376 2.46243 5.5 5.5 5.5h11c3.0376 0 5.5-2.4624 5.5-5.5v-11c0-3.03757-2.4624-5.5-5.5-5.5zm5.5 7c-2.20914 0-4 1.79086-4 4 0 2.2091 1.79086 4 4 4 2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4zm-6 4c0-3.31371 2.68629-6 6-6 3.3137 0 6 2.68629 6 6 0 3.3137-2.6863 6-6 6-3.31371 0-6-2.6863-6-6zm12-8c-1.1046 0-2 .89543-2 2s.8954 2 2 2 2-.89543 2-2-.8954-2-2-2z" fill="#000" fill-rule="evenodd" /></svg>
                                </a>
                                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/akcent-healthcare-india-pvt-ltd/about/">

                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>

                                </a>

                                <a target="_blank" href="https://wa.me/919315914499">
                                    <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m435.921875 74.351562c-48.097656-47.917968-112.082031-74.3242182-180.179687-74.351562-67.945313 0-132.03125 26.382812-180.445313 74.289062-48.5 47.988282-75.234375 111.761719-75.296875 179.339844v.078125.046875c.0078125 40.902344 10.753906 82.164063 31.152344 119.828125l-30.453125 138.417969 140.011719-31.847656c35.460937 17.871094 75.027343 27.292968 114.933593 27.308594h.101563c67.933594 0 132.019531-26.386719 180.441406-74.296876 48.542969-48.027343 75.289062-111.71875 75.320312-179.339843.019532-67.144531-26.820312-130.882813-75.585937-179.472657zm-180.179687 393.148438h-.089844c-35.832032-.015625-71.335938-9.011719-102.667969-26.023438l-6.621094-3.59375-93.101562 21.175782 20.222656-91.90625-3.898437-6.722656c-19.382813-33.425782-29.625-70.324219-29.625-106.71875.074218-117.800782 96.863281-213.75 215.773437-213.75 57.445313.023437 111.421875 22.292968 151.984375 62.699218 41.175781 41.03125 63.84375 94.710938 63.824219 151.152344-.046875 117.828125-96.855469 213.6875-215.800781 213.6875zm0 0" /><path d="m186.152344 141.863281h-11.210938c-3.902344 0-10.238281 1.460938-15.597656 7.292969-5.363281 5.835938-20.476562 19.941406-20.476562 48.628906s20.964843 56.40625 23.886718 60.300782c2.925782 3.890624 40.46875 64.640624 99.929688 88.011718 49.417968 19.421875 59.476562 15.558594 70.199218 14.585938 10.726563-.96875 34.613282-14.101563 39.488282-27.714844s4.875-25.285156 3.414062-27.722656c-1.464844-2.429688-5.367187-3.886719-11.214844-6.800782-5.851562-2.917968-34.523437-17.261718-39.886718-19.210937-5.363282-1.941406-9.261719-2.914063-13.164063 2.925781-3.902343 5.828125-15.390625 19.3125-18.804687 23.203125-3.410156 3.894531-6.824219 4.382813-12.675782 1.464844-5.851562-2.925781-24.5-9.191406-46.847656-29.050781-17.394531-15.457032-29.464844-35.167969-32.878906-41.003906-3.410156-5.832032-.363281-8.988282 2.570312-11.898438 2.628907-2.609375 6.179688-6.179688 9.105469-9.582031 2.921875-3.40625 3.753907-5.835938 5.707031-9.726563 1.949219-3.890625.972657-7.296875-.488281-10.210937-1.464843-2.917969-12.691406-31.75-17.894531-43.28125h.003906c-4.382812-9.710938-8.996094-10.039063-13.164062-10.210938zm0 0" /></svg>
                                </a>
                            </div>
                        </div>

                        {/* <div className="footer-about">
                            <h4>Links</h4>
                            <ul>
                                <li>
                                    <Link to={"/"} onClick={up}>Home</Link></li>
                                <li><Links
                                    activeClass="active"
                                    to="about"
                                    spy={true}
                                    smooth={true}
                                    offset={-40}
                                    duration={100}
                                >
                                    About
                                </Links></li>
                                <li><Links
                                    activeClass="active"
                                    to="contact"
                                    spy={true}
                                    smooth={true}
                                    offset={-30}
                                    duration={100}
                                >
                                    Contact Us
                                </Links></li>
                                <li><Links
                                    activeClass="active"
                                    to="buy"
                                    spy={true}
                                    smooth={true}
                                    offset={-30}
                                    duration={100}
                                >
                                    Buy Now
                                </Links></li>

                            </ul>
                        </div> */}

                        <div className="footer-contact">
                            <h4>Contact</h4>
                            <ul>
                                <li>
                                    <div className="svg">
                                        <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Call"><path d="m52.5 42.85-2.83-2.82a5.9873 5.9873 0 0 0 -8.48 0l-1.27 1.26a1.9573 1.9573 0 0 1 -1.83.54c-2.1-.47-5.49-1.92-9.74-6.17-4.26-4.26-5.71-7.65-6.18-9.75a1.9573 1.9573 0 0 1 .54-1.83l1.27-1.27a6.01768 6.01768 0 0 0 0-8.48l-2.83-2.83a6.01143 6.01143 0 0 0 -8.48 0l-.87.87a10.64659 10.64659 0 0 0 -2.89 9.89c1.49 6.71 6.41 15.28 11.98 20.85 5.57 5.56 14.14 10.49 20.84 11.98a10.96437 10.96437 0 0 0 2.34.26 10.68538 10.68538 0 0 0 7.56-3.15l.87-.87a6.01143 6.01143 0 0 0 0-8.48z"></path></g></svg>
                                    </div>

                                    <a href="tel:+911145009554">+91-1145009554</a>

                                </li>
                                <li>
                                    <div className="svg">
                                        <svg viewBox="0 -77 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m490.753906 0h-469.507812l234.753906 234.453125zm0 0"></path><path d="m0 21.179688v316.445312l158.425781-158.222656zm0 0"></path><path d="m256 276.851562-76.347656-76.25-158.40625 158.203126h469.507812l-158.40625-158.203126zm0 0"></path><path d="m353.574219 179.402344 158.425781 158.222656v-316.445312zm0 0"></path></svg>
                                    </div>

                                    <a href="mailto:akcenthealthcare@gmail.com">akcenthealthcare@gmail.com</a>
                                </li>
                                <li>
                                    <div className="svg">
                                        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-105.6 0-191.5 85.9-191.5 191.5 0 34.4 16.2 77.8 49.4 132.7 27.6 45.6 61.8 90.9 91.9 130.8 13.9 18.4 27 35.8 37.1 50.2 3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8c10.1-14.4 23.2-31.8 37.1-50.2 30.1-39.9 64.2-85.2 91.9-130.8 33.2-54.9 49.4-98.3 49.4-132.7 0-105.6-85.9-191.5-191.5-191.5zm0 280c-48.8 0-88.5-39.7-88.5-88.5s39.7-88.5 88.5-88.5 88.5 39.7 88.5 88.5-39.7 88.5-88.5 88.5z"></path></svg>
                                    </div>

                                    7/27, Block 8, Kirti Nagar Industrial Area Delhi-110015
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer-copyright">
                        <p>&copy; 2024 Akcent Healthcare. All rights reserved.</p>

                        <div className="copy">
                            <Link to={"/privacy-policy"}>Privacy Policy</Link>
                        </div>
                    </div>
                </footer>
            </Element>
        </>

    )
}

export default Home2